<template>
  <div class="mt-4 container operation-column">
    <div
      v-for="uniqueButton in unique_buttons"
      :key="uniqueButton.name"
      class="mb-3 columns"
      :style="`grid-column:${uniqueButton.gridCol};grid-row:${uniqueButton.gridRow};`"
      >
      <div class="column p-1 is-half is-flex is-justify-content-end is-align-items-center">
        <Checkbox
          v-model="uniqueButton.checked"
          :checked="uniqueButton.checked"
          @input="(e) => onCheck(e, uniqueButton)" />
      </div>
      <div class="column p-1">
        <button
          @click="uniqueButton.fn(uniqueButton.checked)"
          class="unique_button button is-small mx-4"
          :class="{ 'is-info': choosenMethod == uniqueButton.infoClass }">
          {{ uniqueButton.display_text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox'
export default {
  name: 'OperationsCheckboxes',
  components: {
    Checkbox
  },
  props: {
    positionId: {
      type: [String, Number],
      required: true
    },
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      position: null,
      unique_buttons: [
        {
          name: 'method_default',
          display_text: 'Default',
          infoClass: 'd',
          fn: this.methodDefault,
          checked: false,
          gridCol: '1',
          gridRow: '1'
        },
        {
          name: 'method_1',
          display_text: 'Method #1',
          infoClass: '1',
          fn: this.methodOne,
          checked: false,
          gridCol: '1',
          gridRow: '2'
        },
        {
          name: 'method_2',
          display_text: 'Method #2',
          infoClass: '2',
          fn: this.methodTwo,
          checked: false,
          gridCol: '1',
          gridRow: '3'
        },
        {
          name: 'method_3',
          display_text: 'Method #3',
          infoClass: '3',
          fn: this.methodThree,
          checked: false,
          gridCol: '1',
          gridRow: '4'
        },
        {
          name: 'method_texts',
          display_text: 'Texts',
          infoClass: 't',
          fn: this.methodTexts,
          checked: false,
          gridCol: '1',
          gridRow: '5'
        },
        {
          name: 'method_4',
          display_text: 'Method #4',
          infoClass: '4',
          fn: this.methodFour,
          checked: false,
          gridCol: '1',
          gridRow: '6'
        },
        {
          name: 'method_5',
          display_text: 'Method #5',
          infoClass: '5',
          fn: this.methodFive,
          checked: false,
          gridCol: '2',
          gridRow: '3'
        },
        {
          name: 'method_6',
          display_text: 'Method #6',
          infoClass: '6',
          fn: this.methodSix,
          checked: false,
          gridCol: '2',
          gridRow: '4'
        },
        {
          name: 'method_10',
          display_text: 'Method #10',
          infoClass: '10',
          fn: this.methodTen,
          checked: false,
          gridCol: '2',
          gridRow: '5'
        }
      ]
    }
  },
  computed: {
    choosenMethod () {
      return this.$route.query.m
    }
  },
  created () {
    this.init()
  },
  methods: {
    onCheck (e, method) {
      if (e) this.createdStat(method.name)
      this.updateSideText(method.name)
    },
    init () {
      this.$network_utils.getPosition({ id: this.positionId }).then(response => {
        this.position = response
      })
      this.$network_utils
        .getStats({
          designator: 'position_search_method',
          date_from: this.$moment().format('YYYY-MM-DD 00:00:01'),
          date_to: this.$moment().format('YYYY-MM-DD 23:59:59'),
          resource_type: 'Position',
          resource_id: this.positionId
        })
        .then((response) => {
          this.unique_buttons = this.unique_buttons.map((item) => {
            const alert = response.find((a) => a.title.includes(item.name))
            if (alert) {
              return {
                ...item,
                checked: true,
                side_text: `נלחץ ע"י ${alert.owner} ב ${this.$moment(
                  alert.created_at
                ).format('DD/MM/YYYY hh:mm')}`
              }
            }
            return item
          })
        })
    },
    updateSideText (method) {
      const btn = this.unique_buttons.find((b) => b.name.includes(method))
      btn.side_text = `נלחץ ע"י ${
        this.$utils.getOwner().name
      } ב ${this.$moment().format('DD/MM/YYYY hh:mm')}`
    },
    methodDefault () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 'd',
          position_id: this.positionId,
          company_id: this.companyId,
          statuses: 'awaiting_company,system_strong,awaiting_applicant_strong,awaiting_admin_intake,expired_before_sent',
          sort: 'distance'
        }
      })
    },
    methodOne () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 1,
          position_id: this.positionId,
          company_id: this.companyId,
          statuses: 'awaiting_admin',
          sort: 'distance'
        }
      })
    },
    methodTwo () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 2,
          position_id: this.positionId,
          company_id: this.companyId,
          statuses: 'awating_applicant,filtered_out',
          filter_by_related: 'TRUE',
          sort: 'distance'
        }
      })
    },
    methodThree () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 3,
          position_id: this.positionId,
          company_id: this.companyId,
          statuses: 'awaiting_admin,awating_applicant,filtered_out',
          filter_by_connected: 'TRUE',
          sort: 'distance'
        }
      })
    },
    methodFour () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 4,
          position_id: this.positionId,
          company_id: this.companyId,
          statuses: 'awaiting_applicant',
          sort: 'distance'
        }
      })
    },
    methodFive () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 5,
          position_id: this.positionId,
          company_id: this.companyId,
          statuses: 'company_rejected,company_rejected_advanced,expired_after_sent,company_familiar,applicant_rejected_advnaced,expired_advanced',
          sort: 'distance'
        }
      })
    },
    methodSix () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 6,
          position_id: this.positionId,
          company_id: this.companyId,
          statuses: 'applicant_rejected,expired_before_sent,admin_rejected,awaiting_admin_later',
          sort: 'distance'
        }
      })
    },
    async methodTen () {
      const [ result ] = await this.$network_utils.getPositionJobTitle({ position_id: this.positionId })
      const skills = this.position.positions_skills.map(s => s.skill.id).join(',')
      let query = {
        m: 10,
        position_id: this.positionId,
        company_id: this.companyId,
        min_salary_expectations: this.position.max_salary_expectations,
        sort: 'distance',
        skills
      }
      if (result) {
        query = {
          ...query,
          one_position_job_titles: result.job_title.id.toString(),
          min_experience: result.min_experience ? result.min_experience.toString() : undefined,
          max_experience: result.max_experience ? result.max_experience.toString() : undefined
        }
      }
      this.$router.push({ name: this.$route.name, query })
    },
    methodTexts () {
      this.$router.push({
        name: this.$route.name,
        query: {
          m: 5,
          company_id: this.companyId,
          position_id: this.positionId,
          sort: 'distance',
          animation: 'TRUE'
        }
      })
    },
    createdStat (text) {
      this.$network_utils.postStat({
        designator: 'position_search_method',
        priority: 5,
        resource_type: 'Position',
        resource_id: this.positionId,
        owner: this.$utils.getOwner().name,
        title: `Position search: ${text}`,
        content: `${
          this.$utils.getOwner().name
        } - ${text} - ${this.$moment().format('DD-MM-YYYY')}`
      })
    }
  }
}
</script>

<style scoped>
.container {
  width: 25%;
  position: absolute;
  right: 5%;
}
.operation-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
